import { useTranslation } from "react-i18next";

import { Card, CardActionsHeader, CardTextContent } from "@/components/Card";
import { DragHandle } from "@/components/drag-columns/components/DragItem";
import { IconButton } from "@/components/IconButton";
import { TextContent } from "@/components/TextContent";

import type { NoteWidget } from "./NoteCard";

export function StaticNoteCard({ widget, onEdit }: { widget: NoteWidget; onEdit?: () => void }) {
  const { t } = useTranslation();

  return (
    <Card>
      <DragHandle>
        <CardActionsHeader title={widget.title}>
          {!!onEdit && <IconButton type="button" name="settings" onClick={onEdit} aria-label={t("edit-note")} />}
        </CardActionsHeader>
      </DragHandle>
      <CardTextContent className="flex flex-col gap-4">
        <TextContent content={widget.content} />
      </CardTextContent>
    </Card>
  );
}
